import React, { Component } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Admin from "./admin";
import Logo from "./images/logo.png";
import axios from 'axios';

class App extends Component {
  state = {
    isLoading: false,
    data: []
  };

  componentDidMount() {
    // this.OrderDetails();
  }

  OrderDetails = async () => {
    try {
      let url = "https://hbm-tracking-backend.vercel.app/";
      const headers = {
        'Content-Type': 'application/json',
        'email': document.getElementById("phonenumber").value,
        };
      const response = await axios.get(url, {headers});
      this.setState({data: response.data})
      this.updateItems(response.data);
    } catch (error) {
        alert("We Got into an error! Please try again after some time")
    }
  }

  updateItems = (data) => {


    for (let index = 0; index < data.length; index++) {
      let order = document.createElement("div");

      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];      

      let date = new Date(data[index].created_at);
      let dateMDY = `${date.getDate()}-${months[date.getMonth()]}-${date.getFullYear()}`;

      if(data[index].fulfillment_status == null) {
        order.innerHTML = `
        <div class="order">
        <p>Order Price - &#x20B9;${data[index].current_total_price}</p><br/>
        <p>Order Date - ${dateMDY}</p><br/>
        <b><p>We will dispatch your order soon!</p></b>
    `;
      }

      else {      
        order.innerHTML = `
      <div class="order np">
      <p>Order Price - &#8377;${data[index].current_total_price}</p><br/>
      <p>Order Date - ${dateMDY}</p><br/>
      <a href=${data[index].fulfillments[0].tracking_url}><button class="btn btn-primary">Track</button></a>
      </div>                
    `;
}

      document.getElementById("allorders").append(order);
      this.setState({isLoading: false});
  }

  }

  trackOrder = () => {

    this.setState({ isLoading: true });

    document.getElementById("allorders").innerHTML = "";

    this.OrderDetails();


    // let phonenumber = document.getElementById("phonenumber").value;

    // if (phonenumber.length !== 10) {
    //   alert("Invalid Phone Number");
    //   this.setState({ isLoading: false });
    // } else {
    //   var firebaseConfig = {
    //     apiKey: "AIzaSyD_l1BF58RX8kOhTSZw6eN2O1cxKNesk4k",
    //     authDomain: "hbm-tracking-page.firebaseapp.com",
    //     databaseURL: "https://hbm-tracking-page-default-rtdb.firebaseio.com/",
    //     projectId: "hbm-tracking-page",
    //     storageBucket: "hbm-tracking-page.appspot.com",
    //     messagingSenderId: "983280525533",
    //     appId: "1:983280525533:web:d2f99dfc1ba09788d4fb34",
    //   };
    //   // Initialize Firebase
    //   if (!firebase.apps.length) {
    //     firebase.initializeApp(firebaseConfig);
    //   } else {
    //     firebase.app(); // if already initialized, use that one
    //   }
    //   var database = firebase.database();
    //   var ref = database.ref("hbmpagetracking");
    //   ref.on("value", getData, errData);

    //   function errData(err) {
    //     alert("Oops an error occurred! Please try again after some time");
    //   }
    // }
  };

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/admin">
            <Admin />
          </Route>
          <div className="App">
            <div className="bar"></div>
            <br />
            <div
              style={{
                display: this.state.isLoading ? "none" : "block",
              }}
              className="mainContent"
            >
              <img src={Logo} alt="" width="100" />
              <br />
              <br />

              <h1 className="title">HomeBakers Mart</h1>
              <div>
                <div className="form">
                  <input
                    type="email"
                    className="form-control1"
                    id="phonenumber"
                    placeholder="Enter Your Email Id"
                    style={{
                      width: "80%",
                    }}
                  />
                  <button className="searchicon" onClick={this.trackOrder}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="white"
                      class="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                    </svg>{" "}
                  </button>
                </div>
                <br />
                <br />

                <div id="allorders"></div>
              </div>
            </div>

            <footer>
              <p>&copy; 2021 HomeBakers Mart - All Rights Reserved.</p>
            </footer>

            <center>
              <div
                class="spinner-border"
                role="status"
                style={{
                  display: this.state.isLoading ? "block" : "none",
                }}
              >
                <span class="visually-hidden">Loading...</span>
              </div>
            </center>
          </div>
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
